<ng-container *ngIf="isHamburgerMenuItem">
  <button mat-menu-item (click)="onToggleTheme()">
    <mat-icon>{{ themeIconName$ | async }}</mat-icon>
    <span>{{ switchThemeLabel }}</span>
  </button>
</ng-container>

<ng-container *ngIf="!isHamburgerMenuItem">
  <button
    mat-icon-button
    [attr.aria-label]="themeTooltipLabel$ | async"
    [matTooltip]="themeTooltipLabel$ | async"
    (click)="onToggleTheme()"
  >
    <mat-icon>{{ themeIconName$ | async }}</mat-icon>
  </button>
</ng-container>
